import axios from 'axios'
import { setInterceptors } from './axiosInterceptors'
import store from '../../store/index'

function createAxiosService () {
	const axiosService = axios.create({
		baseURL: 'https://stat.mcst.go.kr/portal/api/'
	})
	return setInterceptors(axiosService, store)
}

const axiosService = createAxiosService();

/**
 * cancel token map
 *
 * @type {{}}
 */
const axiosCancelMap = {};

/**
 * create cancel token
 *
 * @param key
 * @returns {CancelToken|*}
 */
export function getCancelToken(key) {
  if(axiosCancelMap.hasOwnProperty(key))
    return axiosCancelMap[key];

  const cancelToken = axios.CancelToken;
  const source = cancelToken.source();

  axiosCancelMap[key] = source.token;
  return source.token;
}

export default axiosService
